<template>
  <div style="flex:1 0 auto;position:relative;">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">
        <component :is="`Fiche${itemTypeName}`" />       
        <v-layout v-if="showActionArea" class="pt-2 adm-button" row wrap >
          <v-btn @click.prevent="remove">{{$t('Admin.Remove')}}<v-icon right>mdi-delete</v-icon></v-btn>          
        </v-layout>                 
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import FicheGlider from '@/components/admin/glider/FicheGlider.vue'
import FicheUser from '@/components/admin/user/FicheUser.vue'
import FicheAdminMission from '@/components/admin/adminMission/FicheAdminMission.vue'
import FicheAdminFleet from '@/components/admin/adminFleet/FicheAdminFleet.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm'


@Component({
  name: 'Fiche', 
  props:{
    itemid:Number,
    itemTypeName:String,
    showActionArea:{
      type:Boolean,
      default:true
    }
  },
  components:{FicheGlider,FicheUser,FicheAdminMission,FicheAdminFleet}
})
export default class Fiche extends Vue {  
  itemid!:number
  itemTypeName!:string
  showActionArea!:boolean 
 
  /*Cycle de vie*/
  created() {               
    //@ts-ignore
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_ENSURE_LIST`]().then(() => {this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SELECT_DETAIL`](this.itemid)})    
  }

  @Watch('$route')
  onRouteChanged(to: string, oldVafroml: string) {
    //@ts-ignore
      this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SELECT_DETAIL`](this.itemid)
  }

  get status():string{
    //@ts-ignore
    return this.$store.myGetters[`${camelCase(this.itemTypeName)}Status`]
  }

  get loading():boolean{
    //@ts-ignore
    return this.$store.myGetters[`${camelCase(this.itemTypeName)}Loading`]
  }  

  remove(){
    this.$confirm(this.$t('Admin.DeleteDialogMessage').toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {
          //@ts-ignore
          this.$store.myActions[`${this.itemTypeName.toUpperCase()}_DELETE_REQUEST`]()
        } 
      })    
  }

}
</script>